export function gtag(..._args) {
  window.dataLayer?.push(arguments);
}
